import React from "react";

function OtherApplicationsIcon() {
      return (
            <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  fill="none"
                  viewBox="0 0 24 25"
            >
                  <path
                        stroke="#005BB2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M22 10.97v5c0 5-2 7-7 7H9c-5 0-7-2-7-7v-6c0-5 2-7 7-7h5"
                  ></path>
                  <path
                        stroke="#005BB2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M22 10.97h-4c-3 0-4-1-4-4v-4l8 8z"
                  ></path>
            </svg>
      );
}

export default OtherApplicationsIcon;
